import React, { Component } from 'react';
import { Link } from 'react-router';

class ProductManualResult extends Component {
	render() {
		const product = this.props.data;
		const { name, image, manualLink, modelNumber, discontinued } = product;
		return (
			<div className="product-manual-result">
				<figure className="product-image">
					<img
						src={ image }
						alt={ name }
					/>
				</figure>
				<div className="row">
					<div className="col xs-7">
						<h3 className="product-name">{ name }</h3>
						<p className="product-model">
							Model { modelNumber + (discontinued ? ' (discontinued)' : '') }
						</p>
					</div>
					<div className="col xs-5">
						{
							manualLink ?
							(
								<Link
									className="product-manual-download"
									to={ manualLink }
									target="_blank"
								>
									<span className="fa fa-download" aria-hidden="true" />
									Download PDF
								</Link>
							) : <span className="product-manual-download">We're sorry, the product manual is not available.</span>
						}
					</div>
				</div>
			</div>
		);
	}
}

export default ProductManualResult;


// WEBPACK FOOTER //
// ./src/pages/support/productManuals/ProductManualResult.js